import { Typography } from "@mui/material";
import React from "react";
import { MonthlyReportKeyHighlights } from "../MonthlyReportKeyHighlights/MonthlyReportKeyHighlights";
import { ExecutiveSummaryCards } from "../executiveSummaryCards/ExecutiveSummaryCards";

export const ReportExecutiveSummary = ({ data, month }) => {
  return (
    <div className="report-executive-summary-container">
      <Typography sx={{ fontWeight: "bold" }} variant="h4">
        Executive Summary
      </Typography>
      <Typography
        sx={{ fontWeight: "bold", marginBottom: "10px" }}
        variant="body1"
      >
        (Reporting Cycle: From 26th {month.prev_month} 2024 to 25th{" "}
        {month.selected_month} 2024)
      </Typography>
      <ExecutiveSummaryCards data={data} />
      <MonthlyReportKeyHighlights data={data} month={month} />
      <Typography>
        <strong>Support and Hand Holding: </strong>
        We have done periodic reminder phone calls to the schools to engage
        teachers with smart class content. This intervention has improved the
        smart class content adoption. We have resolved various technical issues
        for smooth functioning of the Smart Classes.
      </Typography>
      <ul>
        <li>
          The school’s administrators are being updated with the latest usage
          report in their school WhatsApp groups. More details in Appendix D
        </li>
      </ul>
      <hr />
      <Typography>
        The above usage data is calculated exclusively on the usage of Aveti
        content during the smart class session. For example, if a teacher
        conducts a 45 minutes’ session on the smart board out of which he/she
        takes 30 minutes to explain the 15 minutes of Aveti content then in our
        report it will be considered only 15 minutes. So, these numbers should{" "}
        <strong>not be interpreted as “smart class usage”.</strong>
        The smart class usage might be higher than the{" "}
        <strong>“Aveti Content Usage”.</strong>
      </Typography>
      <hr />
    </div>
  );
};
